import { useMemo, memo } from 'react';

import { getSanitizedInnerHTML } from 'app/shared/utils/utils';

import { Text1St } from './DealerImprint.css';

export interface IDealerImprint {
  imprint?: string | null;
  name?: string | null;
  streetName?: string | null;
  houseNumber?: string | null;
  zip?: string | null;
  city?: string | null;
  phone?: string | null;
  email?: string | null;
}
const DealerImprintCmp = ({
  imprint = null,
  name = null,
  streetName = null,
  houseNumber = null,
  zip = null,
  city = null,
  phone = null,
  email = null,
}: IDealerImprint): JSX.Element => {
  const safeImprint = useMemo(() => getSanitizedInnerHTML(imprint), [imprint]);

  if (imprint) {
    return <Text1St as="div" dangerouslySetInnerHTML={safeImprint} />;
  }
  return (
    <Text1St as="div">
      {name && <div>{name}</div>}
      {streetName && (
        <div>
          {streetName} {houseNumber}
        </div>
      )}
      {(zip || city) && (
        <div>
          {zip} {city}
        </div>
      )}
      <br /> {/* BREAK */}
      {phone && <div>Telefon: {phone}</div>}
      {email && <div>E-Mail: {email}</div>}
    </Text1St>
  );
};

DealerImprintCmp.displayName = 'DealerImprint';
export const DealerImprint = memo(DealerImprintCmp);
